import useCollectedUserData from './useCollectedUserData';

const useUserBadges = () => {
  const { userBadges } = useCollectedUserData();
  return userBadges;
};

export default useUserBadges;
